module.exports = __webpack_public_path__ + "img/clientSlide06Img_01.33ccab64.png";